import React from 'react'

import { Application } from '../../../types'
import { Box, Button, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, TextField } from '@mui/material'
import ClearIcon from '@mui/icons-material/Clear'

interface Props {
  nameFilter: string
  emailFilter: string
  application: string
  dateFrom: string
  dateTo: string
  onNameFilterChange: (value: string) => void
  onEmailFilterChange: (value: string) => void
  onApplicationChange: (value: string) => void
  onDateFromChange: (value: string) => void
  onDateToChange: (value: string) => void
  onClear: () => void
}

const applicationOptions = Object.values(Application)

const AuthLogFilters: React.FC<Props> = ({
  nameFilter,
  emailFilter,
  application,
  dateFrom,
  dateTo,
  onNameFilterChange,
  onEmailFilterChange,
  onApplicationChange,
  onDateFromChange,
  onDateToChange,
  onClear,
}) => {
  const hasFilters = nameFilter !== '' || emailFilter !== '' || application !== '' || dateFrom !== '' || dateTo !== ''

  return (
    <Box sx={{ mb: 2, display: 'flex', gap: 1.5, flexWrap: 'wrap', alignItems: 'center' }}>
      <TextField
        label="Filter by name"
        variant="outlined"
        value={nameFilter}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onNameFilterChange(e.target.value)}
        sx={{ minWidth: 200, flex: 1 }}
      />
      <TextField
        label="Filter by email"
        variant="outlined"
        value={emailFilter}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onEmailFilterChange(e.target.value)}
        sx={{ minWidth: 200, flex: 1 }}
      />
      <FormControl variant="outlined" sx={{ minWidth: 200, flex: 1 }}>
        <InputLabel id="application-filter-label">Application</InputLabel>
        <Select
          labelId="application-filter-label"
          value={application}
          onChange={(e: SelectChangeEvent<string>) => onApplicationChange(e.target.value)}
          label="Application"
        >
          <MenuItem value="">
            <em>All</em>
          </MenuItem>
          {applicationOptions.map((app) => (
            <MenuItem key={app} value={app}>
              {app}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <TextField
        label="From"
        type="datetime-local"
        variant="outlined"
        value={dateFrom}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onDateFromChange(e.target.value)}
        slotProps={{ inputLabel: { shrink: true } }}
        sx={{ minWidth: 200, flex: 1 }}
      />
      <TextField
        label="To"
        type="datetime-local"
        variant="outlined"
        value={dateTo}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onDateToChange(e.target.value)}
        slotProps={{ inputLabel: { shrink: true } }}
        sx={{ minWidth: 200, flex: 1 }}
      />
      {hasFilters && (
        <Button color="secondary" size="medium" onClick={onClear} startIcon={<ClearIcon />}>
          Clear
        </Button>
      )}
    </Box>
  )
}

export default AuthLogFilters
